import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import { useGetAllLineTypesList } from "../../Parameters/Lines/LineTypes/api/getAllLineTypesList";


const AtmSearchForm = ({ initialValues, onSubmit, onClearForm }: AtmSearchFormProps) => {
  const { t } = useTranslation();
  const getAllLineTypesListQuery = useGetAllLineTypesList();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                <FormikTextbox 
                  label={"Περιγραφή"} 
                  fieldName={"description"}
                />
              </Col>

             {/*  <Col xs={6}>
                <FormikTextbox
                  label={"Κωδικός SAP"}
                  fieldName={"sapCode"}
                />
              </Col> */}

              <Col xs={6} className="d-none">
                <FormikTextbox 
                  label={"Κωδικός Μονάδας"} 
                  fieldName={"unID"}
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Διαγραμμένες")} 
                  fieldName={"deleted"}
                >
                  <option value="">{t("Όχι")}</option>
                  <option value="true">{t("Ναι")}</option>
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Κωδικός ΑΤΜ"} 
                  fieldName={"atmTerm"}
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Τύπος Γραμμής")} 
                  fieldName={"lineType"}
                >
                  <option value="">{t("Επιλέξτε τύπο Γραμμής")}</option>
                  {getAllLineTypesListQuery.data &&
                    getAllLineTypesListQuery.data.map((lineType) => (
                      <option key={lineType.id} value={lineType.description}> { /* it was dificult for api so we send the string for the search */}
                        {lineType.description}
                      </option>
                    ))}
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Σχόλια"} 
                  fieldName={"comments"}
                />
              </Col>
              
            </Row>
            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={onClearForm}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default AtmSearchForm;

type AtmSearchFormProps = {
  initialValues: IAtmSearchForm;
  onSubmit: (
    values: IAtmSearchForm,
    formikHelpers: FormikHelpers<IAtmSearchForm>
  ) => void;
  onClearForm: () => void;
}